module.exports = __webpack_public_path__ + "static/img/23_pro.7a50c1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/23_pro.jpg
// module id = +lP0
// module chunks = 0